import { FC, ReactNode } from 'react';
import { NotStonksIcon } from '../../../../../../../assets/svg/not-stonks';
import { StonksIcon } from '../../../../../../../assets/svg/stonks';
import { Card } from '../../../../../../../components/card/card';
import { useLang } from '../../../../../../../hooks/use-lang';
import s from './dashboard-card.module.css';

export interface DashboardCardProps {
  title: string;
  icon?: ReactNode;
  content?: string;
  delta?: number;
}

export const DashboardCard: FC<DashboardCardProps> = (props) => {
  const { content, delta = 0, icon, title } = props;
  const { t } = useLang();

  let stonksIcon = null;
  if (delta > 0) stonksIcon = <StonksIcon />;
  if (delta < 0) stonksIcon = <NotStonksIcon />;

  return (
    <Card className={s.feature}>
      <div className={s.header}>
        <div className={s.content}>
          <span className={s.title}>{t(title)}</span>
          <span className={s.content}>{t(content || 'Недоступно')}</span>
        </div>
        {icon}
      </div>
      {stonksIcon && (
        <div className={s.delta}>
          {stonksIcon}
          <span className={s.deltaValue}>
            <span className={delta > 0 ? s.green : s.red}>{delta}% </span>
            {t(delta > 0 ? 'Больше' : 'Меньше')} {t('чем вчера')}
          </span>
        </div>
      )}
    </Card>
  );
};
